import React from 'react'
type Props = React.PropsWithChildren<{
  fallback?: React.ReactNode
  onError?: (error: Error) => void
}>
type State = { failed: boolean }
export default class AiWidgetErrorBoundary extends React.Component<Props, State> {
  state: State = { failed: false }
  static getDerivedStateFromError(): State { return { failed: true } }
  componentDidCatch(error: Error) {
    window.elasticApm?.captureError?.(error)
    this.props.onError?.(error)
    if (typeof ENV !== 'undefined' && ENV.dev) console.error('[AI Widget] Render error', error)
  }

  render() { return this.state.failed ? (this.props.fallback || null) : this.props.children }
}
